import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Title} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {JhiEventManager} from 'ng-jhipster';
import {Observable, Subject} from 'rxjs';
import {map, takeUntil} from 'rxjs/operators';
import {Principal} from '@app/core';
import {Area, netHouses} from '@shared/model/area.model';
import {AreaService} from '@shared/services/area.service';

import {DonViService} from '@entities/don-vi';
import {GiongService} from '@entities/giong';
import {IGiong} from '@entities/giong/giong.model';
import {Crops, IGuidelines} from '@entities/canh-tac/canh-tac.model';
import {CanhTacService} from '@entities/canh-tac/canh-tac.service';

@Component({
  selector: 'app-them-lo-dialog',
  templateUrl: './canh-tac-dialog.component.html',
})
export class CanhTacDialogComponent implements OnInit {
  lo: Crops;
  isSaving: boolean;
  area$: Observable<Area[]>;
  netHouses$: netHouses[];
  supPlies$: IGiong[];
  guideLine$: IGuidelines[];
  cropType: any;
  minDate: Date;
  check: boolean;
  customerData: any;
  customerId = null;
  private unsubscribeAll = new Subject();

  constructor(
    private dialogRef: MatDialogRef<CanhTacDialogComponent>,
    private canhTacService: CanhTacService,
    private giongService: GiongService,
    private eventManager: JhiEventManager,
    private areaService: AreaService,
    private titleService: Title,
    private translate: TranslateService,
    private principal: Principal,
  ) {
    this.isSaving = false;
    this.lo = new Crops();
    this.cropType = [];
    this.customerData = [];
  }

  ngOnInit() {
    this.principal
      .getAuthenticationState()
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((user) => {
        if (user) {
          this.customerId = user.customerId;
          if (user.customerId) {
            this.lo.tbCustomerId = this.lo.tbCustomerId || user.customerId;
            this.getArea(this.lo.tbCustomerId);
          } else {
            this.getArea();
          }
        }
      });
    // this.canhTacService.guideLine('NONG_NGHIEP').subscribe((res: any) => {
    //   this.guideLine$ = res.body ? res.body : [];
    // });
    // this.canhTacService.listCropType('NONG_NGHIEP').subscribe((res: any) => {
    //   this.cropType = res.body ? res.body : [];
    // });
    // this.giongService.queryDropdownList().subscribe((res: any) => {
    //   this.supPlies$ = res.body ? res.body : [];
    // });
    this.getNetHouses(0);
    if (this.lo.id !== null) {
      this.titleService.setTitle(
        this.translate.instant(
          'entities.canh-tac.canh-tac-dialog.Sửa lô_title',
        ),
      );
    } else {
      this.titleService.setTitle(
        this.translate.instant(
          'entities.canh-tac.canh-tac-dialog.Thêm lô_title',
        ),
      );
    }
  }

  save() {
    this.isSaving = true;
    if (this.lo.id !== null) {
      this.canhTacService.update(this.lo).subscribe(
        (response) => this.onSaveSuccess(response),
        () => this.onSaveError(),
      );
    } else {
      this.canhTacService.create(this.lo).subscribe(
        (response) => this.onSaveSuccess(response),
        () => this.onSaveError(),
      );
    }
  }

  private onSaveSuccess(result) {
    this.isSaving = false;
    this.eventManager.broadcast({
      name: 'loListModification',
      content: 'Lo',
    });
    this.dialogRef.close(true);
  }

  private onSaveError() {
    this.isSaving = false;
  }

  getNetHouses(id: number) {
    if (id) {
      this.areaService.listNetHousesByArea(id).subscribe((res: any) => {
        this.netHouses$ = res.body ? res.body : [];
      });
    } else {
      this.areaService.listNetHousesAll().subscribe((res: any) => {
        this.netHouses$ = res.body ? res.body : [];
      });
    }
  }

  getArea(customerId = ''): void {
    this.area$ = this.areaService
      .listArea({customerId: customerId})
      .pipe(map((res) => (res.body ? res.body : [])));
  }

  onCustomerChange(event: any) {
    if (event) {
      this.lo.areaId = null;
      this.getArea(event);
    }
  }

  onAreaChange(event: any) {
    if (event) {
      this.lo.areaId = event;
      this.getNetHouses(event);
    }
  }

  onGuideType(event: any) {
    if (event) {
      this.lo.guideType = event;
      this.canhTacService.guideLine(event).subscribe((res: any) => {
        this.guideLine$ = res.body ? res.body : [];
      });
      this.canhTacService.listCropType(event).subscribe((res: any) => {
        this.cropType = res.body ? res.body : [];
      });
      this.giongService.queryDropdownList(event).subscribe((res: any) => {
        this.supPlies$ = res.body ? res.body : [];
      });
    }
  }
}

@Component({
  selector: 'app-canh-tac-popup',
  template: '',
})
export class CanhTacPopupComponent implements OnInit, OnDestroy {
  private dialogRef: MatDialogRef<CanhTacDialogComponent>;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private titleService: Title,
    private donViService: DonViService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    setTimeout(() => {
      this.dialogRef = this.dialog.open(CanhTacDialogComponent, {
        disableClose: true,
        width: '380px',
      });
      this.donViService.dropdown().subscribe((data: any) => {
        this.dialogRef.componentInstance.customerData = data.body;
      });

      this.dialogRef.afterClosed().subscribe(
        (result) => {
          this.router.navigate([{outlets: {popup: null}}], {
            replaceUrl: true,
            queryParamsHandling: 'merge',
          });
        },
        (reason) => {
          this.router.navigate([{outlets: {popup: null}}], {
            replaceUrl: true,
            queryParamsHandling: 'merge',
          });
        },
      );
    }, 0);
  }

  ngOnDestroy() {
    this.titleService.setTitle(
      this.translate.instant(
        'entities.canh-tac.canh-tac-dialog.Danh sách lô_title',
      ),
    );
    this.dialogRef = null;
  }
}
